var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeadphones = function SvgHeadphones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M5.286 5.286A6.667 6.667 0 0 1 16.666 10v.833H15a2.5 2.5 0 0 0-2.5 2.5v2.5a2.5 2.5 0 0 0 2.5 2.5h.833a2.5 2.5 0 0 0 2.5-2.5V10a8.333 8.333 0 0 0-16.666 0v5.833a2.5 2.5 0 0 0 2.5 2.5H5a2.5 2.5 0 0 0 2.5-2.5v-2.5a2.5 2.5 0 0 0-2.5-2.5H3.333V10c0-1.768.703-3.464 1.953-4.714M3.333 12.5v3.333a.833.833 0 0 0 .834.834H5a.833.833 0 0 0 .833-.834v-2.5A.833.833 0 0 0 5 12.5zm13.334 0H15a.833.833 0 0 0-.833.833v2.5a.833.833 0 0 0 .833.834h.833a.833.833 0 0 0 .834-.834z",
    clipRule: "evenodd"
  })));
};
export default SvgHeadphones;